
import { Injectable } from "@angular/core";
import { CameraOptions, Camera } from '@ionic-native/camera';
import { Platform } from 'ionic-angular';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { GreatdayPluginNative, GDICamera } from './greatday-plugin.native';
import { GlobalServiceProvider } from "../providers/global-service/global-service";

export const enum CameraSource {
	PHOTOLIBRARY = 0,
	CAMERA = 1,
	SAVEDPHOTOALBUM = 2
}

@Injectable()
export class CameraNative {

	constructor(
		public camera: Camera,
		private platform: Platform,
		private greatdayPluginNative: GreatdayPluginNative,
		private androidPermissions: AndroidPermissions,
		private globalServiceProvider: GlobalServiceProvider
	) {

	}

	/**
		* Ambil foto dari kamera hp dan gallery
		* @param options 
		*/
	getPicture(options: CameraOptions) {
		return new Promise<GDICamera>(async (resolve) => {
			await this.platform.ready();
			await this.getCameraPermission();
			let response: GDICamera;
			if (this.platform.is('android')) {
				if (options.sourceType) {
					// ambil gambar dari kamera handphone android
					response = await this.greatdayPluginNative.getCameraSwap();
				} else {
					// ambil gambar dari gallery handphone android
					response = await this.getCamera(options);
				}
			}
			else {
				// ambil gambar dari kamera & gallery handphone ios
				response = await this.getCamera(options);
			}

			resolve(response);
		})
	}

	/**
		* Camera bisa buat android dan ios
		* @param data 
		*/
	getCamera(opt: CameraOptions) {
		return new Promise<GDICamera>(async (resolve) => {
			let response = {
				nativeURL: "",
				base64Image: "",
				cancelled: false
			}

			try {
				const options: CameraOptions = {
					quality: opt.quality || 80,
					destinationType: this.camera.DestinationType.FILE_URI,
					sourceType: opt.sourceType ? this.camera.PictureSourceType.CAMERA : this.camera.PictureSourceType.PHOTOLIBRARY,
					allowEdit: opt.allowEdit || false,
					encodingType: this.camera.EncodingType.JPEG,
					targetWidth: opt.targetWidth || 500,
					targetHeight: opt.targetHeight || 500,
					saveToPhotoAlbum: false,
					cameraDirection: opt.cameraDirection || 0,
					correctOrientation: true
				}

				const imageData = await this.camera.getPicture(options);
				const getFilePath = this.globalServiceProvider.getFilePath(imageData);
				const uriToFile = await this.globalServiceProvider.convertUriToFile(getFilePath.path, getFilePath.filename);
				const base64Image = await this.globalServiceProvider.convertFileToBase64(uriToFile);

				response.base64Image = base64Image;
				response.nativeURL = imageData;
				console.log('imageData', imageData);
			} catch (error) {
				console.log('cordova camera error', error);
				response.cancelled = true;
			}

			resolve(response);
		})
	}

	/**
		* Cek permission camera
		*/
	getCameraPermission(): Promise<any> {
		if (this.platform.is('android')) {
			return this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.CAMERA)
				.then(success => {
					if (!success.hasPermission) {
						return this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.CAMERA)
					};
				})
		} else {
			return Promise.resolve();
		}
	}

}


// WEBPACK FOOTER //
// ./src/native/camera.native.ts